import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * InputMask - основной аттрибут inputmask, указывает на то, что будет использоваться кастомная реализация маски для элмента
 * inputmaskplaceholder - заменяет placeholder
 * используется маска взятая с options по типу указанному в аттрибует inputmask по регулярке /^type\:(.*?)$/g
 * если под регулярку не попадаем то используем ту маску что указана в значении аттрибута
 */
export class InputMaskBehaviour extends BaseEmptyPrefixControlBehaviour {
    private inputMaskFn: Function = undefined;

    constructor() {
        super('inputmask');
    }

    protected installCondition(element: any): boolean {
        return !!$(element).inputmask;
    }

    protected installBehaviour(element: HTMLElement): void {
        let inputMask: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            null,
            {}
        );

        let mask = this.getBehaviorValue(element);
        const placeholder = $(element).attr(this.tag + 'placeholder');
        if (mask) {
            const maskTypeRegex = /^type\:(.*?)$/g;
            const typeMatch = maskTypeRegex.exec(mask);
            if (typeMatch) {
                const maskType = typeMatch[1];
                inputMask = $.extend(
                    true,
                    {},
                    this.options.types.inputMask[maskType] || {},
                    inputMask
                );
                mask = inputMask.mask;
                inputMask.mask = undefined;
            }

            if (placeholder !== undefined) {
                inputMask.placeholder = placeholder;
            }
            $(element).inputmask(mask, inputMask);
        } else if (inputMask) {
            $(element).inputmask(inputMask);
        }
        if (inputMask.clearbtn) {
            $(inputMask.clearbtn).click(() => {
                $(element).inputmask('setvalue', '');
               
            });
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.InputMaskBehaviour = InputMaskBehaviour;